import { render, staticRenderFns } from "./automation-grid.vue?vue&type=template&id=5b1fb4ca&scoped=true"
import script from "./automation-grid.vue?vue&type=script&lang=js"
export * from "./automation-grid.vue?vue&type=script&lang=js"
import style0 from "./automation-grid.vue?vue&type=style&index=0&id=5b1fb4ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1fb4ca",
  null
  
)

export default component.exports